<template>
  <div>
    <div class="row selects-periodo">
      <div class="col-md-4">
        <b-form-select
          v-model="valueYear"
          :options="years"
          size="sm"
          class="mt-3"
          value-field="id"
          text-field="value"
          @change="$emit('reload')"
        ></b-form-select>
      </div>

      <div class="col-md-8">
        <b-form-select
          v-model="valueMonth"
          :options="months"
          size="sm"
          class="mt-3"
          value-field="id"
          text-field="value"
          @change="$emit('reload')"
        ></b-form-select>
      </div>
    </div>

    <area-graph
      :loading="false"
      :data="items"
      :titulo="title"
      :sizearea="sizearea ? sizearea : '170px'"
      :sizecard="sizecard ? sizecard : '220px'"
    />
  </div>
</template>

<script>
export default {
  props: [
    "months",
    "years",
    "items",
    "title",
    "sizearea",
    "sizecard",
    "year",
    "month",
  ],
  data() {
    return {
      valueYear: moment().format("YYYY"),
      valueMonth: null,
    };
  },
  created() {
    this.valueYear = this.year;
    this.valueMonth = this.month;
  },
  watch: {
    valueYear(n, o) {
      this.$emit("update:year", n);
    },
    valueMonth(n, o) {
      this.$emit("update:month", n);
    },
  },
};
</script>

<style scoped>
.selects-periodo {
  position: absolute;
  z-index: 9;
  background: #fff;
  right: 15px;
  width: 50%;
}
</style>
